import { FC } from 'react'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import {
  useSelected,
  AllSelector,
  AllSelectorProps,
  CheckBoxList,
  CheckBoxListProps,
  Selects
} from '../parts'
import {
  SelectPanelWrapper,
  SelectPanelWrapperProps
} from '../SelectPanelWrapper'

const styles = {
  wrap: css({
    border: `1px solid ${palette.gray2}`,
    padding: 12,
    marginTop: 8
  })
}

export interface SimpleSelectPanelProps {
  headerTools?: SelectPanelWrapperProps['headerTools']
  title: SelectPanelWrapperProps['title']
  caption?: SelectPanelWrapperProps['caption']
  initials?: Selects
  items: CheckBoxListProps['items']
  allSelectorLabel: AllSelectorProps['label']
  handleSubmit: SelectPanelWrapperProps['handleSubmit']
  submitButtonText: SelectPanelWrapperProps['submitButtonText']
  submitButtonLeftText?: SelectPanelWrapperProps['submitButtonLeftText']
  onChange?: (v: Selects) => void
  submitDisabled?: boolean
}

export const SimpleSelectPanel: FC<SimpleSelectPanelProps> = ({
  items,
  initials,
  headerTools,
  title,
  caption,
  allSelectorLabel,
  handleSubmit,
  submitButtonText,
  submitButtonLeftText,
  onChange,
  submitDisabled
}) => {
  const { selects, setSelects, isAllSelected, handleAllSelect } = useSelected(
    items.filter(({ disabled }) => !disabled).map(({ value }) => value),
    initials,
    onChange
  )

  return (
    <SelectPanelWrapper
      title={title}
      headerTools={headerTools}
      caption={caption}
      submitButtonText={submitButtonText}
      submitButtonLeftText={submitButtonLeftText}
      handleSubmit={handleSubmit}
      selects={selects}
      submitDisabled={submitDisabled}
    >
      <AllSelector
        onChange={handleAllSelect}
        checked={isAllSelected}
        label={allSelectorLabel}
      />
      <div css={styles.wrap}>
        <CheckBoxList
          name={allSelectorLabel}
          values={selects}
          onChange={setSelects}
          items={items}
        />
      </div>
    </SelectPanelWrapper>
  )
}
